import gsap from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

import App from '../../assets/js/app';

import AnimationController from '../../assets/js/controllers/animation';
import DetectController from '../../assets/js/controllers/detect';
import ScrollController from '../../assets/js/controllers/scroll';

import Newsletter from '../../assets/js/components/newsletter';

import { map, lerp, getRootOffset } from '../../assets/js/helpers';

gsap.registerPlugin(MorphSVGPlugin);

export default class Footer {

	isDesktop;
	isActive = false;

	animation;

	timeline;

	timeout;

	mouse = {
		x: 0,
		y: 0,
		progress: 0
	};

	static selector = 'footer';

	el = {};

	constructor(container) {
		this.el = {
			container,
			heading: container.querySelector(`.${this.constructor.selector}__heading`),
			newsletter: container.querySelector(`.${this.constructor.selector}__newsletter`),
			pathDefault: container.querySelector('#good-things-default path'),
			pathWide: container.querySelector('#good-things-wide path'),
			pathCondensed: container.querySelector('#good-things-condensed path')
		};

		this.isDesktop = DetectController.isDesktop;

		this.newsletter = new Newsletter(this.el.newsletter);

		if (this.isDesktop) {
			this.measure();

			this.mouse = {
				x: this.bounds.headingWidth * 0.5,
				y: 0,
				progress: 0.5
			};

			this.timelineSvg = gsap.timeline({
				paused: true,
				defaults: {
					ease: 'linear'
				}
			});

			this.timelineSvg
				.to(this.el.pathCondensed, {
					morphSVG: {
						shape: this.el.pathDefault,
						map: 'complexity'
					}
				}, 'default')
				.to(this.el.pathCondensed, {
					morphSVG: {
						shape: this.el.pathWide,
						map: 'complexity'
					}
				}, 'wide');

			this.timelineSvg.seek('wide');

			this.addEventListeners();
			this.start();
		}

		this.newsletter.init();
	}

	addEventListeners() {
		this.el.heading.addEventListener('mousemove', this.#onMouseMove);

		App.on('preloadComplete', this.#onPageUpdate);
		App.on('pageTransition', this.#onPageUpdate);
	}

	removeEventListeners() {
		this.el.heading.removeEventListener('mousemove', this.#onMouseMove);

		App.off('preloadComplete', this.#onPageUpdate);
		App.off('pageTransition', this.#onPageUpdate);
	}

	measure() {
		const containerBounds = getRootOffset(this.el.container);
		const headingBounds = getRootOffset(this.el.heading);

		this.bounds = {
			headingWidth: this.el.heading.clientWidth,
			headingTop: headingBounds.top,
			headingLeft: headingBounds.left,
			containerTop: containerBounds.top,
			winHeight: window.innerHeight
		};
	}

	#onMouseMove = (e) => {
		this.mouse.x = e.touches ? e.touches[0].clientX - this.bounds.headingLeft : e.clientX - this.bounds.headingLeft;
		this.mouse.y = e.touches ? e.touches[0].clientY - this.bounds.headingTop : e.clientY - this.bounds.headingTop;
	};

	#onPageUpdate = () => {
		this.measure();
	}

	// Animations

	start() {
		this.animation = AnimationController.set({
			update: this.#update,
			render: this.#render
		});
	}

	stop() {
		AnimationController.clear(this.animation);
		this.animation = null;
	}

	#update = () => {
		if (ScrollController.eased + this.bounds.winHeight >= this.bounds.containerTop) {
			this.mouse.progress = lerp(this.mouse.progress, map(this.mouse.x, 0, this.bounds.headingWidth, 0, 1), 0.1);
			return true;
		}
	}

	#render = () => {
		this.timelineSvg.progress(this.mouse.progress);
	}

	destroy() {
		if (this.isDesktop) {
			this.stop();
			this.removeEventListeners();
		}
		this.newsletter.destroy();
	}

}
